import shallowequal from 'shallowequal';

var isShallowEquals = function isShallowEquals(a, b) {
  if (!Array.isArray(a) || !Array.isArray(b)) {
    return shallowequal(a, b);
  }

  if (a.length !== b.length) {
    return false;
  }

  for (var key = 0; key < a.length; key += 1) {
    if (!(key in b)) {
      return false;
    }

    if (!shallowequal(a[key], b[key])) {
      return false;
    }
  }

  return true;
};

export default isShallowEquals;